'use client';

import {usageModesContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderLight, sectionPadding, SectionContainer, SectionHeader} from './shared';

export function UsageModesSection() {
  return (
    <section id={usageModesContent.id} aria-labelledby="usage-modes-heading" className={`${sectionPadding} bg-white ${sectionBorderLight} relative`}>
      <SectionContainer>
        <FadeIn>
          <SectionHeader
            badge="Modos de uso"
            title={usageModesContent.title}
            description={usageModesContent.description}
          />
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {usageModesContent.modes.map((mode, index) => {
            const Icon = mode.icon;
            return (
              <FadeIn key={mode.title} delay={index * 0.1} className="h-full">
                <article className={`h-full bg-kobra-bg border border-kobra-border rounded-2xl p-6 lg:p-8 hover:border-kobra-accent/40 ${cardHoverClass}`}>
                  <div className="w-11 h-11 bg-kobra-accent-soft rounded-xl flex items-center justify-center text-kobra-accent mb-5">
                    <Icon className="w-5 h-5" aria-hidden="true" />
                  </div>
                  <h3 className="text-xl font-bold text-kobra-text-dark mb-2">{mode.title}</h3>
                  <p className="text-kobra-text-muted text-sm leading-relaxed mb-5">{mode.description}</p>
                  <ul className="flex flex-wrap gap-2">
                    {mode.items.map((item) => (
                      <li
                        key={item}
                        className="text-xs font-medium text-kobra-accent bg-kobra-accent-soft px-3 py-1.5 rounded-full"
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </article>
              </FadeIn>
            );
          })}
        </div>
      </SectionContainer>
    </section>
  );
}
